import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { MenuModal as MessengerMenuModal } from '../components/menuModal';
const translatePayload = (node) => {
    const { payload: { options }, } = node;
    return options.map(({ id, label, nextNodeId }) => ({
        id: id,
        label,
        connection: nextNodeId || uuid(),
    }));
};
const updateConnection = (node, connection, connectionId) => {
    const { payload } = node;
    const { options } = payload;
    const newOptions = options.concat();
    const labelIndex = options.findIndex((opt) => opt.label === connection.connectionLabel);
    if (labelIndex !== -1) {
        newOptions[labelIndex] = Object.assign(Object.assign({}, options[labelIndex]), { nextNodeId: connectionId });
    }
    return Object.assign(Object.assign({}, node), { payload: Object.assign(Object.assign({}, payload), { options: newOptions }) });
};
export const MessengerMenuNodeAttributes = {
    iconName: 'channels',
    label: 'Menu',
    color: hexStringToNumber(flowNodeColor.purple),
    translatePayload,
    updateConnection,
    NodeContent: MessengerMenuNode,
    ActionModal: MessengerMenuModal,
    helpText: 'Allow users to choose a path and simple ask clickable questions',
};
export function MessengerMenuNode({ node, }) {
    const { payload } = node;
    const { options } = payload;
    const optionCount = Object.keys(options).length;
    const optionText = optionCount === 1 ? 'Option' : 'Options';
    return (_jsx(TextContent, { children: useMemo(() => (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: `${optionCount} ${optionText}` }) })), [optionCount, optionText]) }));
}
